<template>
  <q-btn v-bind="getProps" @click="openFreshWidget" />
</template>
<script>
export default {
  props: {
    icon: {
      type: String,
    },
    color: {
      type: String,
    },
    customProps: {
      type: Object,
      default: () => ({
        flat: true,
      }),
    },
  },
  computed: {
    getProps() {
      let defaultProps = {
        icon: this.icon || 'fas fa-headset',
        color: this.color || 'primary',
      }
      return { ...this.customProps, ...defaultProps }
    },
  },
  methods: {
    openFreshWidget() {
      if (window && window.FreshWidget) {
        window.FreshWidget.show()
      }
    },
  },
}
</script>
